export default "__VITE_ASSET__BcHTLI8F__"